// extracted by mini-css-extract-plugin
export default {"container":"hawk-promotion-deal-container","main":"hawk-promotion-deal-main","chevron":"hawk-promotion-deal-chevron"};